import { __extends } from "tslib";
import React, { Component } from 'react';
import { MoloRingloader } from './layout/MoloRingloader';
import MissingBanner from './images/logobanner.jpg';
;
var CollectionChooser = /** @class */ (function (_super) {
    __extends(CollectionChooser, _super);
    function CollectionChooser() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loadedImageKeys = new Set();
        _this.revealFallbackTimer = null;
        _this.state = {
            imagesIsLoded: false,
        };
        _this.clearRevealFallback = function () {
            if (_this.revealFallbackTimer !== null) {
                window.clearTimeout(_this.revealFallbackTimer);
                _this.revealFallbackTimer = null;
            }
        };
        _this.scheduleRevealFallback = function () {
            _this.clearRevealFallback();
            _this.revealFallbackTimer = window.setTimeout(function () {
                _this.setState({ imagesIsLoded: true });
            }, 2500);
        };
        _this.resetImageLoading = function () {
            _this.loadedImageKeys.clear();
            var collectionCount = _this.props.collections ? _this.props.collections.length : 0;
            if (!collectionCount) {
                _this.clearRevealFallback();
                _this.setState({ imagesIsLoded: true });
                return;
            }
            _this.setState({ imagesIsLoded: false });
            _this.scheduleRevealFallback();
        };
        _this.markImageLoaded = function (imageKey, collectionCount) {
            if (_this.loadedImageKeys.has(imageKey)) {
                return;
            }
            _this.loadedImageKeys.add(imageKey);
            if (collectionCount <= _this.loadedImageKeys.size) {
                _this.clearRevealFallback();
                _this.setState({ imagesIsLoded: true });
            }
        };
        _this.bindImageRef = function (imageKey, collectionCount) { return function (el) {
            if (el && el.complete && el.naturalWidth > 0) {
                _this.markImageLoaded(imageKey, collectionCount);
            }
        }; };
        return _this;
    }
    CollectionChooser.prototype.componentDidMount = function () {
        this.resetImageLoading();
    };
    CollectionChooser.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.collections !== this.props.collections) {
            this.resetImageLoading();
        }
    };
    CollectionChooser.prototype.componentWillUnmount = function () {
        this.clearRevealFallback();
    };
    CollectionChooser.prototype.isOdd = function (num) { return num % 2; };
    CollectionChooser.prototype.render = function () {
        var _this = this;
        var collections = this.props.collections || [];
        var showLoader = collections.length > 0 && !this.state.imagesIsLoded;
        var getImage = function (imgUrl, imageKey) {
            return (React.createElement("img", { ref: _this.bindImageRef(imageKey, collections.length), src: _this.props.loadImage && _this.props.loadImage(imgUrl), className: "card-list__item__image", onError: function (el) {
                    el.target.src = MissingBanner;
                    el.target.classList.add('missing');
                    _this.markImageLoaded(imageKey, collections.length);
                }, onLoad: function () { return _this.markImageLoaded(imageKey, collections.length); } }));
        };
        return (React.createElement(React.Fragment, null,
            showLoader &&
                React.createElement("div", { style: { height: '100vh', width: '100vw', position: 'fixed' } },
                    React.createElement(MoloRingloader, null)),
            React.createElement("div", { className: "card-list__wrapper " + ((!showLoader) ? "fade-in" : ""), style: { visibility: showLoader ? 'hidden' : 'visible' } },
                React.createElement("ul", { className: "card-list" + ((collections.length > 2) ? ' card-list--small' : '') },
                    collections.map(function (collection) {
                        return collection.collectionName && React.createElement("li", { key: collection.collectionName, className: "card-list__item" },
                            React.createElement("div", { onClick: function () { return _this.props.handleOnClick && _this.props.handleOnClick(collection.collectionName); }, className: "card-list__item__link" },
                                getImage(collection.imgUrl, collection.collectionName),
                                React.createElement("div", { className: "card-list__item__title" }, collection.collectionName || '?!?')));
                    }),
                    collections.length && this.isOdd(collections.length) ?
                        React.createElement("li", { className: "card-list__item" },
                            React.createElement("div", { className: "card-list__item__link --not-active" },
                                React.createElement("img", { src: MissingBanner, alt: 'missing placeholder', className: "card-list__item__image --no-hover --placeholder missing" })))
                        :
                            null))));
    };
    return CollectionChooser;
}(Component));
export { CollectionChooser };
export default CollectionChooser;
//# sourceMappingURL=CollectionsChooser.js.map